'use strict';
namespace TR {

    angular
    .module('TR')
    .directive('parkingSelection', () => {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                captureParking: '=',
                model: '=',
                parking: '=',
                rootForm: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=ParkingSelection'
        };
    });
}
